export default __webpack_public_path__ + "static/media/arrow-forward.b0d02173.svg";